import {Component} from 'react';
import './TfIdf.scss';
import IconPadlock from './IconPadlock.js';
import languages from '../languages.js';
import LanguageInfo from './LanguageInfo';
import Fetch from '../lib/Fetch.js';

class TfIdf extends Component {

	constructor(props) {
		super(props);
		this.state = {
			language: languages.find((lang) => lang.langCode === this.props.appSettings.language),
			tfData: [],
			working: false,
		}

		this.handleLangChange = this.handleLangChange.bind(this);
		this.handleTfidfClick = this.handleTfidfClick.bind(this);
	}

	componentDidUpdate() {
		if (this.props.appSettings.language !== this.state.language.langCode) {
			this.setState({
				language: languages.find((lang) => lang.langCode === this.props.appSettings.language),
			})
		}
	}

	handleLangChange(event) {
		this.languages.forEach((lang) => {
			if (lang.value === event.target.value) {
				this.setState({
					language: lang,
				});
				return;
			}
		});
	}

	getFileContents(file) {
		return new Promise((resolve) => {
			fetch(file)
			.then((response) => {
				if (response.status < 400) {
					return response.text();
				}
				resolve({});
			})
			.then((respData) => resolve(respData))
			.catch((error) => {
				console.error(error);
				resolve({});
			})
		});
	}

	async calculateTermFreq() {
		if (!this.state.language || !this.state.language.tfidf) {
			return;
		}
		let file = `stopwords/${this.state.language.langCode}.txt`;
		let fileContent = await this.getFileContents(file);

		const stopWords = fileContent.split(/\r?\n/);
		const arrayUnique = function (value, index, self) {
			return self.indexOf(value) === index;
		}

		let content = this.props.text.replace(/(<([^>]+)>)/gi, ' ');
		content = content.replace(/&[a-z];/g, ' ');
		content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
		content = content.toLowerCase();
		let words = content.split(' ');
		words = words.filter(arrayUnique);
		words = words.filter((word) => !stopWords.includes(word) && isNaN(word) && word.length > 1);

		let termCount = words.length;

		let tfData = words.map((term) => {
			let regex = new RegExp(`( )*${term} `, 'g');
			let count = (content.match(regex) || []).length;
			let tf = (count / termCount);
			return {
				term: term,
				tf: tf
			}
		});
		tfData.sort((a, b) => (a.tf > b.tf) ? -1 : (a.tf < b.tf) ? 1 : 0);
		tfData = tfData.slice(0, 10);

		let oldData = JSON.stringify(this.state.tfData);
		let newData = JSON.stringify(tfData);
		if (newData !== oldData) {
			this.setState({
				tfData: tfData
			});
		}
	}

	async handleTfidfClick(event) {
		event.preventDefault();
		this.setState({
			working: true,
		});

		const data = await this.fetchTfidf();
		if (!data.length) {
			return;
		}
		this.setState({
			working: false,
			tfData: data.splice(0, 10),
		});
	}

	async fetchTfidf() {
		let content = this.props.text.replace(/(<([^>]+)>)/gi, ' ');
		content = content.replace(/&[a-z];/g, ' ');
		content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
		content = content.toLowerCase();
		let words = content.split(' ').filter((word) => !!word);

		const response = await Fetch.post('/tools/tf-idf/ajax/compute_tf_idf.php', {
			websiteWords: [],
			wordCount: 0,
			lang: null,
			free: 0,
			competitorWords: {
				'https://diagnoseo.com/tools/content': words
			},
		});

		return response.table || {
			status: 'error',
			message: 'Fetching TF-IDF failed',
		};
	}

	render() {
		if (!this.props.isPro) {
			return (<p className="in-pro"><IconPadlock /> <b><a href="https://diagnoseo.com/pricing/" target="_blank" rel="noreferrer noopener">Unlock</a></b></p>);
		}
		if (!this.state.language || !this.state.language.tfidf) {
			return (
			<>
				<LanguageInfo language={this.state.language} toggleSettingsCallback={this.props.toggleSettingsCallback} />
				<p><IconPadlock /> Not available for current language</p>
			</>
			);
		}

		const tfItems = [];
		if (this.state.language) {
			tfItems.push(<li className="tf-data-item" key="0"><b className="tf-data-term">Word</b><b className="tf-data-tf">TF-IDF</b></li>);
			if (this.state.tfData.length) {
				this.state.tfData.forEach((item, index) => {
					let key = 'tfdata-item-' + index;
					tfItems.push(<li className="tf-data-item" key={key}><span className="tf-data-term">{item.word}</span><span className="tf-data-tf">{item.tf_idf.toFixed(3)}</span></li>)
				});
			}
		}

		const tfList = this.state.tfData.length ? (<ul className="tf-data">{tfItems}</ul>) : '';
		const loading = this.state.working ? ' Fetching TF-IDF data...' : '';
		return (
			<>
			<LanguageInfo language={this.state.language} toggleSettingsCallback={this.props.toggleSettingsCallback} />
			<p className="main-button"><button className="button primary" onClick={this.handleTfidfClick}>Refresh</button>{loading}</p>
			{tfList}
			</>
		)
	}

}

export default TfIdf;